import Vue from 'vue'
import Vuex from 'vuex'
import state from '@/plugins/state'

Vue.use(Vuex)

const store = new Vuex.Store({
  strict: true,
  state,
  mutations: {
  },
  actions: {
  }
})

export default store
